import _ from 'underscore';

import View from './view';





export default View.extend( {

    setLocations(locations) {
        this.locations_ = locations;
        return this.render();
    },

    clearLocations() {
        return this.setLocations( null );
    },

    events: {
        'click .glyphicon-remove': function() {
            this.clearLocations();
        }
    },

    onBind(model) {
        this.listenTo( model, 'change:point', 
            () => this.render() );
        this.listenTo( model, 'change:type_id',
            () => this.render() );
        this.listenTo( model, 'change:assigned_organization_id',
            () => this.render() );
        this.listenTo( model, 'change:assigned_user_id', 
            () => this.render() );
    },

    serialize() {
        const { locationService, height } = this.options;

        if (this.locations_)
            return {
                mapUsers: this.locations_.filter( loc => !!loc.is_active ),
                zonesInactive: true,
                locationService,
                height,
            };

        return { locationService, };
    },

    afterRender(context, firstTime) {
        if (!firstTime) return;

        this.listenTo( this.Map, 'assignee:click',
            () => this.trigger( 'assignee:click' ) )
        this.listenTo( this.Map, 'assignee:assign',
            user => this.trigger( 'assignee:assign', user ) )
        this.listenTo( this.Map, 'map:click',
            location => this.trigger( 'map:click', location ) )
        this.listenTo( this.Map, 'service-object:choose',
            serviceObjectAttrs => this.trigger( 'map:click', serviceObjectAttrs.coords ) )
        this.listenTo( this.Map, 'address:choose',
            addressAttrs => this.trigger( 'map:click', addressAttrs.coords ) )
    },

} );



// WEBPACK FOOTER //
// ./src/js/view/map.assignees.js